import React, { Component } from 'react';
import { Row, Col, Button, Modal } from 'react-bootstrap';
import _ from 'lodash';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css'; // Include CSS

export default class SamplingMapping extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedregionName: [],
      selectedcenterName: [],
      selectedclientName: [],
      selectedprocessName: [],
      selectedTemplate: [],
    }
    this.bulkclientName = []
  }
  componentDidMount() {
    this.props.action.actioninventoryUserMapped()
  }
  componentWillMount = () => {
    const { inventory } = this.props;
    if (!_.isEmpty(inventory)) {
      let regionNames = _.filter(inventory);
      this.setState({ selectedregionName: regionNames[0] })
    }

  }
  closeModal = () => {
    this.setState({ closeStatus: false })
    this.setState({
      selectedregionName: [], selectedcenterName: [], selectedclientName: [], selectedprocessName: [],
      selectedTemplate: []
    })
  }
  regionNames = (prop) => {
    const { inventory } = this.props;
    if (!_.isEmpty(inventory)) {
      let regionNames = _.filter(inventory);
      return regionNames;
    }
  }
  centerNames = () => {
    const { selectedregionName } = this.state;
    const { inventory } = this.props;
    let centerName = [];
    if (!_.isEmpty(inventory)) {
      centerName = _.filter(selectedregionName.userCenters);
    }
    return centerName;
  }
  clientNames = () => {
    const { selectedcenterName } = this.state;
    const { inventory } = this.props;
    let clientName = [];
    if (!_.isEmpty(inventory)) {
      _.map(selectedcenterName, (obj) => {
        let x = _.filter(obj.userClients);
        clientName.push(...x);
        this.bulkclientName = clientName
      })
      return _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const { selectedclientName } = this.state;
    const { inventory } = this.props;
    let processName = [];
    if (!_.isEmpty(inventory)) {
      _.map(selectedclientName, (obj) => {
        let abc = _.filter(this.bulkclientName, { 'inventoryClientId': obj.inventoryClientId })
        _.map(abc, (z) => {
          processName.push(...z.userProcesses)
          processName = _.uniqBy(processName, 'inventoryProcessId');
        })
      })
      return processName;
    }
  }


  handleSelect = (e) => {
    this.setState({ selectedregionName: e });
    if (!_.isEqual(this.state.selectedregionName, e)) {
      this.setState({ selectedclientName: [], selectedprocessName: [], selectedcenterName: [] })
    }
  }
  handleSelectCenter = (e) => {
    this.setState({ selectedcenterName: e });
    if (!_.isEqual(this.state.selectedcenterName, e)) {
      this.setState({ selectedclientName: [], selectedprocessName: [] })
    }
  }
  handleSelectClient = (e) => {
    this.setState({ selectedclientName: e });
    if (!_.isEqual(this.state.selectedclientName, e)) {
      this.setState({ selectedprocessName: [] })
    }
  }
  handleSelectProcess = (e) => {
    this.setState({ selectedprocessName: e });
  }
  handleSelectTemplate = (e) => {
    this.setState({ selectedTemplate: e });
  }
  validateForm = () => {
    const { selectedclientName, selectedprocessName, selectedcenterName, selectedTemplate } = this.state;
    if (selectedcenterName.length > 0 && selectedclientName.length > 0 && selectedprocessName.length > 0
      && !_.isEmpty(selectedTemplate)) {
      return true
    }
  }
  modalMapStatus = (message) => {
    if (this.props.mapstatus === 1001) {
      return (<Modal show={this.state.closeStatus}
        onHide={this.closeModal}
        dialogClassName="modal-90w shadowClass"
        size='md'
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton><Modal.Title>Save changes
        </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {message}
        </Modal.Body>
        <Modal.Footer>
          <Button className='buttonwidth' onClick={this.finalOK}> OK </Button> &nbsp;
          <Button className='buttonwidth' onClick={this.closeModal}> Cancel </Button>
        </Modal.Footer>
      </Modal>)
    }
  }
  finalOK = () => {
    this.setState({ closeStatus: false })
    this.props.action.TokenValidation()
    this.props.action.mapSamplingTemplateUpdate()
    this.setState({
      selectedregionName: [], selectedcenterName: [], selectedclientName: [], selectedprocessName: [],
      selectedTemplate: []
    })
  }
  mapTemplate = () => {
    this.props.action.TokenValidation()
    const { selectedclientName, selectedprocessName, selectedcenterName, selectedregionName,
      selectedTemplate } = this.state;
    let clients = []; let process = [];
    let centers = _.map(selectedcenterName, (cx) => {

      if (!_.isEmpty(cx.userClients)) {
        _.map(selectedclientName, (obj) => {
          _.map(cx.userClients, val => {
            if (_.isEqual(val.inventoryClientId, obj.inventoryClientId)) {
              if (!_.isEmpty(val.userProcesses)) {
                _.map(selectedprocessName, (object) => {
                  let data = _.filter(val.userProcesses, object)
                  process.push(
                    { 'processId': object.inventoryProcessId, 'processName': object.inventoryProcessName }
                  )
                })
              }
              clients.push(
                { 'clientId': obj.inventoryClientId, 'clientName': obj.inventoryClientName }
              )
            }

          })
        })
      }
      return (
        { 'centerId': cx.inventoryCenterId, 'centerName': cx.inventoryCenterName }
      )
    })
    let object = {
      'region': [{ 'regionId': selectedregionName.inventoryRegionId, 'regionName': selectedregionName.inventoryRegionName }],
      'center': centers,
      'client': clients,
      'process': process,
      'templateId': selectedTemplate.id,
      'templateTitle': selectedTemplate.templateTitle
    }

    // let obj= {
    // 'region':[{"regionId": selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName}],
    // 'center': _.map(selectedcenterName, (obj) => {return {'centerId':obj.inventoryCenterId, 'centerName':
    // obj.inventoryCenterName} }),
    // 'client': _.map(selectedclientName, (obj) => {return {'clientId':obj.inventoryClientId,
    // 'clientName':obj.inventoryClientName } }),
    // 'process': _.map(selectedprocessName, (obj) => {return {'processId':obj.inventoryProcessId,
    // 'processName':obj.inventoryProcessName } }),
    // 'templateId': selectedTemplate.id,
    // 'templateTitle': selectedTemplate.templateTitle
    // }
    this.props.action.mapSamplingTemplate(object)
    this.setState({ closeStatus: true })
  }
  render() {
    return (<div className='margingap'>
      <Row>
        <Col>
          <label>Region Name</label>
        </Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedregionName}
            options={this.regionNames()}
            onChange={this.handleSelect}
            open={false}
            valueKey="inventoryRegionName"
            labelKey="inventoryRegionName"
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Region'
            dropdownHeight={600}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <label>Center Name</label>
        </Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedcenterName}
            options={this.centerNames()}
            onChange={this.handleSelectCenter}
            open={false}
            valueKey="inventoryCenterName"
            labelKey="inventoryCenterName"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Center'
            dropdownHeight={600}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <label>Client Name</label>
        </Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedclientName}
            options={this.clientNames()}
            onChange={this.handleSelectClient}
            open={false}
            valueKey="inventoryClientName"
            labelKey="inventoryClientName"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Client'
            dropdownHeight={600}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <label>Process Name</label>
        </Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedprocessName}
            options={this.processNames()}
            onChange={this.handleSelectProcess}
            open={false}
            valueKey="inventoryProcessName"
            labelKey="inventoryProcessName"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Process Name'
            dropdownHeight={600}
          />
        </Col>
      </Row>


      <Row>
        <Col>
          <label>Sampling Templates</label>
        </Col>
        <Col>
          <Picky keepOpen={false}
            value={this.state.selectedTemplate}
            options={!_.isEmpty(this.props.templates) ? this.props.templates : []}
            onChange={this.handleSelectTemplate}
            open={false}
            valueKey="templateTitle"
            labelKey="templateTitle"
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select Sampling Template'
            dropdownHeight={600}
          />
        </Col>
      </Row>


      <br />
      {this.state.closeStatus ? this.modalMapStatus(this.props.mapmessage) : null}
      <Button onClick={this.mapTemplate} className='buttonwidth' block>MAP</Button>

    </div>)
  }
}


